<script>
import EditGoogleCalendar from './EditGoogleCalendar.vue';
import { googleService } from '../services/google-service';
import Spinner from 'shared/components/Spinner.vue';
import { useAlert } from 'dashboard/composables';
import { emitter } from 'shared/helpers/mitt';

export default {
  components: {
    EditGoogleCalendar,
    Spinner,
  },
  props: {
    calendar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      showEditPopup: false,
      showDeletePopup: false,
      calendarActive: this.calendar.active,
    };
  },
  methods: {
    showAlert(message) {
      emitter.emit('newToastMessage', message);
    },

    // Edit Calendar Function
    openEditPopup() {
      this.showEditPopup = true;
    },
    hideEditPopup() {
      this.showEditPopup = false;
    },

    // Delete Calendar Function
    openDeletePopup() {
      this.showDeletePopup = true;
    },
    closeDeletePopup() {
      this.showDeletePopup = false;
    },

    // Requistions
    async deleteSchedule() {
      this.isLoading = true;
      try {
        const response = await googleService.deleteSchedule(this.calendar.id);
        if (response.status === 200) {
          this.showDeletePopup = false;
          this.$emit('getSchedules');
          useAlert(
            `✅  -  A agenda ${this.calendar.name} foi removida com sucesso`
          );
          this.isLoading = false;
        }
      } catch (error) {
        this.showDeletePopup = false;
        useAlert(
          '❌  - Ocorreu um problema ao tentar excluir sua agenda. Por favor, tente novamente mais tarde'
        );
        this.isLoading = false;
      }
    },
    async updateActiveSchedule() {
      this.isLoading = true;
      this.calendarActive = !this.calendarActive;
      try {
        const response = await googleService.activeSchedule({
          schedule_id: this.calendar.id,
          active: this.calendarActive,
        });
        if (response.status === 200) {
          this.$emit('getSchedules');
          useAlert(
            `✅  -  O status ATIVO da agenda '${this.calendar.name}' foi alterado com sucesso!`
          );
          this.isLoading = false;
        }
      } catch (error) {
        useAlert(
          '❌  - Ocorreu um problema ao tentar atualizar o status ATIVO da sua agenda. Por favor, tente novamente mais tarde'
        );
        this.isLoading = false;
      }
    },
  },
};
</script>

<template>
  <div class="calendar button secondary clear">
    <Spinner v-if="isLoading" size="small" color-scheme="dark" />

    <span class="text-truncate comp1">{{ calendar.name }}</span>
    <woot-dropdown-item class="auto-offline--toggle comp2 gap-2">
      <div class="flex gap-2">
        <fluent-icon
          v-tooltip.right-start="
            $t('INTEGRATION_APPS.GOOGLE_CALENDAR.CALENDARS.ACTIVE_SWITCH_INFO')
          "
          icon="power"
          size="16"
          class="info-icon"
        />

        <span class="text-xs">{{
          $t('INTEGRATION_APPS.GOOGLE_CALENDAR.CALENDARS.ACTIVE_SWITCH_LABEL')
        }}</span>
      </div>

      <woot-switch
        size="small"
        :value="calendarActive"
        @input="updateActiveSchedule"
      />
    </woot-dropdown-item>
    <div class="button-wrapper comp2">
      <woot-button
        v-tooltip.top="$t('INTEGRATION_APPS.GOOGLE_CALENDAR.CALENDARS.EDIT')"
        variant="smooth"
        size="tiny"
        color-scheme="secondary"
        icon="edit"
        class-names="grey-btn"
        @click="openEditPopup()"
      />
      <woot-button
        v-tooltip.top="$t('INTEGRATION_APPS.GOOGLE_CALENDAR.CALENDARS.DELETE')"
        variant="smooth"
        color-scheme="alert"
        size="tiny"
        icon="dismiss-circle"
        class-names="grey-btn"
        @click="openDeletePopup()"
      />
    </div>

    <!-- EDIT CALENDAR -->
    <woot-modal v-model:show="showEditPopup" :on-close="hideEditPopup">
      <EditGoogleCalendar
        v-if="showEditPopup"
        :id="calendar.id"
        :name="calendar.name"
        :active="calendar.active"
        :bookable-times="calendar.bookable_times"
        :blocked-periods="calendar.blocked_periods || []"
        :services="calendar.services"
        :on-close="hideEditPopup"
      />
    </woot-modal>

    <!-- DELETE CALENDAR -->
    <woot-delete-modal
      v-model:show="showDeletePopup"
      :on-close="closeDeletePopup"
      :on-confirm="deleteSchedule"
      :title="`Excluir agenda ${calendar.name}`"
      message="A ação a seguir vai remover a agenda selecionada dessa conta Multiatendedor, excluindo também todas suas personalizações."
      message-value="Deseja prosseguir?"
      confirm-text="SIM"
      reject-text="NÃO"
    />
  </div>
</template>

<style scoped lang="scss">
.calendar {
  display: flex;
  justify-content: space-between;
  line-height: var(--space-normal);
  &:hover {
    cursor: default;
  }

  .comp1 {
    width: calc(40% + 7vw);
    text-align: left;
  }

  .comp2 {
    width: 33.3%;
    display: flex;
    align-items: center;
    justify-content: start;
  }
}
</style>
